import React, { useState } from "react";
import style from "css/landing.module.css";
import { useMediaQuery } from "react-responsive";

function HistoryItem(props) {
  const [isHover, setIsHover] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  return !isMobile && !isTablet ? (
    <div
      className={style.history_item_wrap}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
    >
      <div className={style.history_item_title_wrap}>
        <span className={style.history_item_year}>{props.history.year}</span>
        <span className={style.history_item_title}>{props.history.title}</span>
      </div>
      <div className={style.history_item_img_wrap}>
        <div className={style.history_item_img_wrap_hover_bg} />
        {props.history.type === "img" ? (
          <img
            src={`${
              isHover
                ? process.env.REACT_APP_CLIENT_URL + props.history.img_over
                : process.env.REACT_APP_CLIENT_URL + props.history.img
            }`}
            alt="history"
          />
        ) : (
          <span style={{ color: isHover ? props.history.color : "#a1a1a1" }}>
            {props.history.title}
          </span>
        )}
      </div>
      <div className={style.history_item_text}>{props.history.text}</div>
      <div
        className={style.history_item_hover_bg}
        style={{ backgroundColor: props.history.color }}
      />
    </div>
  ) : (
    <div className={style.history_item_wrap}>
      <div className={style.history_item_img_wrap}>
        {props.history.type === "img" ? (
          <img
            src={`${process.env.REACT_APP_CLIENT_URL + props.history.img_m}`}
            alt="history"
          />
        ) : (
          <span style={{ color: props.history.color }}>
            {props.history.title}
          </span>
        )}
      </div>
      <div className={style.history_item_title_wrap}>
        <span className={style.history_item_title}>{props.history.title}</span>
        <div className={style.history_item_text}>{props.history.text}</div>
      </div>

      <span className={style.history_item_year}>{props.history.year}</span>
    </div>
  );
}

export default HistoryItem;
